import { Card, CardContent, CardTitle } from '@/components/ui/card';
import MarkdownDisplay from '../../../../components/MarkdownDisplay';

import { useCreateProject } from './CreateProjectContext';
import { formatDate } from '@/lib/utils';

export default function ProjectSummaryCard({
  className,
}: {
  className?: string;
}) {
  const { formState } = useCreateProject();
  const deliverableCount = formState.deliverables.length;
  return (
    <Card className={`${className} self-start mb-6 w-full`}>
      <CardTitle className="ml-5">{formState.projectName || '-'}</CardTitle>
      <CardContent className="text-sm grid grid-cols-3 gap-2">
        <div>
          <div className="font-medium">Deliver by</div>
          <div className="text-muted-foreground">
            {formatDate(formState.dueDate)}
          </div>
        </div>
        <div>
          <div className="font-medium">Videos</div>
          <div className="text-muted-foreground">{deliverableCount}</div>
        </div>
        <div className="col-span-3">
          <div className="font-medium">Brief</div>
          <MarkdownDisplay
            content={formState.brief}
            variant="simple"
            size="sm"
            className="text-muted-foreground"
            expandable={true}
            lines={2}
          />
        </div>
      </CardContent>
    </Card>
  );
}
